import {
    CREATE_SJFSERVICES,
    RETRIEVE_SJFSERVICES,
    RETRIEVESINGLE_SJFSERVICES,
    UPDATE_SJFSERVICES,
    DELETE_SJFSERVICES,
  } from "../actions/type";
  const initialState = [];
  function SJFServicesReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case CREATE_SJFSERVICES:
        return {data: state.data, payload};
      case RETRIEVE_SJFSERVICES:
        state = (payload.error == 1)?initialState:payload;
        return {data: state, payload};
      case RETRIEVESINGLE_SJFSERVICES:
        state = (payload.error == 1)?initialState:payload;
        return {data: state.data, payload};
      case UPDATE_SJFSERVICES:
        return {data: state.data, payload};
      case DELETE_SJFSERVICES:
        return {data: state.data, payload};
      default:
        return state;
    }
  };
  export {SJFServicesReducer};